import { render, staticRenderFns } from "./systemAnnouncementModal.vue?vue&type=template&id=eab58732&scoped=true"
import script from "./systemAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./systemAnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./systemAnnouncementModal.vue?vue&type=style&index=0&id=eab58732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab58732",
  null
  
)

export default component.exports